import { Button, message, Table } from 'antd';
import xlsx from 'json-as-xlsx';
import { calculateColumnsWidth } from 'api/common';
import { LoadingScreen } from 'common/components';
import { useCallback, useEffect, useState } from 'react';
import FilterColumns from './FilterColumn';
import moment from 'moment';
import {
  PresentmentDashboard,
  presentmentDashboardFilter,
  PresentmentFilterPaylaod,
  presentmentUpdateFailedToCompleteStatus,
  PresentmentPagedList,
} from 'api/nach';
import { usePresentmentFilterContext } from '../../context/PresenmentFilterProvider';
import { ColumnsType } from 'antd/lib/table';
import ViewAuditModal from '../ViewAuditModal';
import DownloadAuditLogs from '../DownloadAudit';

type Props = {
  // filter: FilterPayload;
  // reload: boolean;
};

// Define an initial state for your paginated list, similar to the sample code.
let initialPresentmentPagedList: PresentmentPagedList = {
  currentPageIndex: 1,
  noOfRecords: 0,
  data: [],
};

function getFullDate(date: string) {
  if (date != null) {
    let dateMoment = moment(new Date(date)).format('YYYY/DD/MM HH:mm:ss');
    return dateMoment;
  }
}
// export const ReloadFilterListContext = createContext<any>(null);

function AutoPayTrueFilterList({ }: Props) {
  const { filter, prevFilter, setFilter, currentActiveTabKey } = usePresentmentFilterContext();
  // const [pagedList, setPagedList] = useState<PresentmentDashboard[]>([]);
  const [pagedList, setPagedList] = useState<PresentmentPagedList>(initialPresentmentPagedList); // Use PresentmentPagedList
  const [isLoading, setIsLoading] = useState(false);
  const [isRetry, setIsRetry] = useState(false);
  const [fetchedDate, setFetchedDate] = useState('');

  // Local state for pagination parameters
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // Default page size

  // filter.Username = sessionStorage.getItem('user')?.toString();
  const isAdmin = sessionStorage.getItem('isAdmin');

  if (isAdmin != 'true') {
    // filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
  }

  useEffect(() => {

    if (!filter || !filter.startDate || !filter.endDate) {
      setIsLoading(true);
      setPagedList(initialPresentmentPagedList);
      // message.warn('Please select date');
      return;
    }
    // If download is requested (isExtract is true), fetch ALL data
    if (filter?.isExtract && currentActiveTabKey == 3) {
      console.log("---DOWNLOAD TRIGGERED for auto Pay true---", filter);
      handleDownloadData();
      return
    }

    setIsLoading(true);
    // if (!filter || !filter.startDate || !filter.endDate) {
    //   return;
    // }

    if (isRetry) {
      fetchAutoPayTableData(currentPage, pageSize);
      setFetchedDate(JSON.stringify(filter));
      setIsRetry(false);
    }
    if (currentActiveTabKey != 3 && prevFilter != JSON.stringify(filter)) {
      return;
    }

    // This is the key change to prevent re-fetching after a download.
    const filterForTableFetch = { ...filter };
    delete filterForTableFetch.isExtract;
    delete filterForTableFetch.pageNo;
    delete filterForTableFetch.pageSize;
    const filterForTableFetchString = JSON.stringify(filterForTableFetch);
    if (fetchedDate != filterForTableFetchString && currentActiveTabKey == 3) {
      fetchAutoPayTableData(currentPage, pageSize);
    }
  }, [isRetry, filter, currentActiveTabKey]);

  const fetchAutoPayTableData = useCallback(
    (page: number, size: number) => {
      //setIsLoading(false); // Start loading
      // setPagedList(initialPresentmentPagedList); // Optionally clear list immediately
      // setFetchedDate(JSON.stringify(filter)); // This is set in useEffect now

      const newFilter: PresentmentFilterPaylaod = {
        ...filter,
        presentmentFlagId: 2,
        pageNo: page, // Pass current page to API
        pageSize: size, // Pass current page size to API
      };

      presentmentDashboardFilter(newFilter)
        .then((res) => {
          console.log('presentment response data autopay true', res);
          // Assuming res.data directly matches PresentmentPagedList structure
          if (res.data) {
            setPagedList(res.data);
          }
        })
        .finally(() => {
          // setIsLoading(true); // End loading
        });
    },
    [filter] // Dependency on filter
  );

  const handleDownloadData = useCallback(() => {
    const downloadPayload: PresentmentFilterPaylaod = {
      ...filter,
      presentmentFlagId: 2, // Assuming this is the correct flag for this list
      isExtract: true, // Confirming extraction
      pageNo: 1, // Or a value your backend understands as "all pages"
      pageSize: pageSize, // Or a value your backend understands as "all items"
    };

    presentmentDashboardFilter(downloadPayload)
      .then((res) => {
        console.log('Download data fetched', res);
        if (res.data && res.data.data.length > 0) { // Ensure res.data and res.data.data exist
          performExcelDownload(res.data.data); // Pass the actual data array
        } else {
          message.destroy();
          message.error('No data found for download in Auto Pay True');
        }
      })
      .catch((error) => {
        console.error('Error fetching data for download:', error);
        message.error('Failed to download data.');
      })
      .finally(() => {
        // setIsLoading(true); // Hide loading after download attempt
        // const resetFilter = { ...filter, isExtract: false };
        // setFilter(resetFilter);
        setFilter((prevFilter: PresentmentFilterPaylaod) => ({
          ...prevFilter,
          isExtract: false,
        }));
        //message.destroy(); // Hide loading message
      });
  }, [filter, setFilter]);
  const performExcelDownload = (dataToDownload: PresentmentDashboard[]) => {
    let settings = {
      fileName: 'presentment_Auto_Pay_true',
      extraLength: 3,
      writeMode: 'writeFile',
      writeOptions: {},
      RTL: false,
    };

    const updatedData = dataToDownload.map((item: any, index) => ({
      ...item,
      NOTIFICATIONDATE: getFullDate(item.notificationDate),
      DATEOFTXN: getFullDate(item.dateOfTxn),
      CREATEDON: getFullDate(item.createdOn),
      ROWNUM: index + 1, // Add the row number (index + 1 to start from 1)
    }));

    let data = [
      {
        sheet: 'Sheet 1',
        columns: [
          { label: 'ROWNUM', value: 'ROWNUM' },
          { label: 'UMRN NO', value: 'umrnNO' },
          { label: 'Corporate Name', value: 'corporateName' },
          { label: 'Corporate User No', value: 'corporateUserNo' },
          { label: 'Amount', value: 'amount' },
          { label: 'Transaction ID REF', value: 'transactionIDREF' },
          { label: 'Unique Reference', value: 'uniqueReference' },
          { label: 'Batch No', value: 'batchNo' },
          { label: 'Created On', value: 'CREATEDON' },
          { label: 'Customer Debit AC', value: 'customerDebitAC' },
          { label: 'Customer MICR', value: 'customerMICR' },
          { label: 'Date Of Transaction', value: 'DATEOFTXN' },
          { label: 'Debitor Name', value: 'debtorName' },
          { label: 'IFSC', value: 'ifsc' },
          { label: 'Loan Type', value: 'loanType' },
          { label: 'Merchant Order Id', value: 'merchantOrderId' },
          { label: 'Merchant Subscription Id', value: 'merchantSubscriptionId' },
          { label: 'Notification Date', value: 'NOTIFICATIONDATE' },
          { label: 'Notify Response Order ID', value: 'notifyResponseOrderID' },
          { label: 'Partner Bank', value: 'partnerBank' },
          { label: 'Pre Notification Status', value: 'preNotificationStatus' },
          { label: 'Presentment Flag', value: 'presentmentFlag' },
          { label: 'Presentment Id', value: 'presentmentId' },
          { label: 'Presentment Status', value: 'presentmentStatus' },
          { label: 'Sourcing Type', value: 'sourcingType' },
          { label: 'Error Code', value: 'errorCode' },
          { label: 'Created By', value: 'userName' },
        ],
        content: updatedData,
      },
    ];
    xlsx(data, settings);
  };
  if (!isLoading) {
    return <LoadingScreen />;
  }

  const handleChange = (_pagination: any, _filters: any, sorter: any) => {
    if (sorter.hasOwnProperty('column')) {
      // params.order = { field: sorter.field, dir: sorter.order };
    }

    // Update local pagination state
    setCurrentPage(_pagination.current);
    setPageSize(_pagination.pageSize);
    setIsLoading(false);

    // filter.Username = sessionStorage.getItem('user')?.toString();
    if (isAdmin != 'true') {
      // filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
    }

    // filter.PageNo = _pagination.current;
    // filter.PageSize = _pagination.pageSize;
    //const newFilter: PresentmentFilterPaylaod = { ...filter, presentmentFlagId: 2 };
    const newFilter: PresentmentFilterPaylaod = {
      ...filter,
      presentmentFlagId: 2,
      pageNo: _pagination.current, // Use the page from Ant Design's pagination
      pageSize: _pagination.pageSize, // Use the page size from Ant Design's pagination
    };
    presentmentDashboardFilter(newFilter)
      .then((res) => {
        if (res.data) {
          setPagedList(res.data);
        }
      })
      .finally(() => {
        setIsLoading(true);
      });
  };
  const maxWidthPerCell = 1000;

  const handleRetry = (record: PresentmentDashboard) => {
    setIsLoading(false);
    presentmentUpdateFailedToCompleteStatus({ presentmentFlagId: record.presentmentId })
      .then((res) => {
        if (res.status == 'SUCCESS') {
          message.destroy();
          message.success('Successfully retry');
          setIsRetry(true);
        }
      })
      .finally(() => {
        setIsLoading(true);
      });
  };
  // const rowKey = 'ROWNUM';
  const ActionColumn: ColumnsType<PresentmentDashboard> = [
    {
      key: 'View',
      title: 'Action',
      dataIndex: 'View',
      ellipsis: true,
      width: 1000,
      align: 'center',
      render: (_, record) => (
        <span
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          }}
        >
          <>
            <ViewAuditModal record={record} />
            <DownloadAuditLogs record={record} />
            {record.presentmentStatus == 'PRESENTMENT_FAILED' ||
              record.presentmentStatus === 'NOTIFY_FAILED' ||
              record.presentmentStatus === 'REDMPTION_FAILED' ? (
              <Button
                onClick={() => {
                  handleRetry(record);
                }}
                type="primary"
              >
                Retry
              </Button>
            ) : null}
          </>
        </span>
      ),
    },
  ];

  const dataTable = calculateColumnsWidth(
    [...FilterColumns, ...ActionColumn],
    pagedList.data || [],
    maxWidthPerCell
  );
  const tableHeight = 500;
  const rowKey = 'ROWNUM';

  return (
    <Table
      style={{ paddingLeft: '0px' }}
      dataSource={dataTable.source}
      columns={dataTable.columns}
      // rowKey={(record) => record.id}
      rowKey={rowKey}

      //pagination={false}
      // pagination={{
      //   pageSize: 10,
      //   // total: pagedList.noOfRecords - 10,
      //   // current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
      // }}
      pagination={{
        pageSize: pageSize, // Use the state variable
        total: pagedList.noOfRecords, // Total records from your API response
        current: pagedList.currentPageIndex === 0 ? 1 : pagedList.currentPageIndex, // Current page from your API response
        showSizeChanger: true, // Allow changing page size
        pageSizeOptions: ['10', '20', '50', '100'], // Options for page size
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`, // Optional: show total items
      }}
      scroll={{ x: dataTable.tableWidth, y: tableHeight }}
      onChange={handleChange}
    />
  );
}

export default AutoPayTrueFilterList;
